<template>
  <div class="voting-module">
    <div class="candidate-container">
      <div class="title-box pt-4">
        <h4>{{item.vname}}</h4>
        <img class="mx-auto" :src="`https://kishoto.ir/dtr/approid/img/${item.img}`" />
        <div class="candidate-name">{{item.name}}</div>
      </div>

      <div class="candidate-lists">
          <div class="video-container" v-if="item.url">
            <video width="320" height="240" controls preload="none">
              <source :src="`https://kishoto.ir/dtr/approid/${item.url}`"  type="video/mp4">
                  Your browser does not support the video tag.
            </video>
          </div>

        <button v-if="!item.voted" class="btn voting-class" type="button" @click="votePerson(item,item.voted)">رای دادن</button>
        <button v-else class="btn voted-class" type="button" @click="votePerson(item,item.voted)">حذف رای</button>

        <div class="comment-container">
          <h4 class="text-right">نظرات</h4>


          <div class="comment-list" v-if="item.cmlist">
            <div class="comment-item d-flex flex-column" v-for="comment in item.cmlist">
              <div class="name-comment-box d-flex flex-row">
                <account-circle-icon />
                <p>{{comment.name}}</p>
              </div>

              <div class="comment-box">
                {{comment.text}}
              </div>
              <div class="comment-date text-left">
                {{comment.date}}
              </div>

            </div>
          </div>

          <div class="input-box d-flex flex-row justify-content-between mb-3 mt-2">
            <button type="button" class="btn submitcomment" @click="putComment">ثبت نظر</button>
            <input type="text" placeholder="نظر شما ..." v-model="commentText">

          </div>


        </div>


      </div>
    </div>
  </div>
</template>

<script>

import PlusIcon from 'vue-material-design-icons/Plus.vue';
import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";

import store from "@/store";

export default {
  data() {
    return {
      item: [],
      itemsPerRow:2,
      resultVoted: null,
      commentText:"",
      votesVoted: null,
      votingtext:"رای دادن"
    };
  },
  components:{
    PlusIcon,
    AccountCircleIcon
  },
  created() {
      this.getCandidate();
  },
  computed:{

  },
  methods: {
    async getCandidate() {
      console.log(this.$route.params);
      let fd = new FormData();
      fd.append("vpid", this.$route.params.id);

      //fd.append("vlid", this.$route.params.vlid);

      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("get_voting_single",fd);
      console.log(response);

      if (response) {
        this.item = response;
      }
    },

    async votePerson(id,voting){

      if(voting){
          this.votingtext = "حذف رای";
      }else{
          this.votingtext = "رای دادن";
      }

      let fd = new FormData();
      //fd.append("vlid", this.$route.params.vlid);
      fd.append("vpid", this.$route.params.id);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("submit_vote",fd);

      if (response.status_code === 200) {
        this.resultVoted = response.result;
        this.votesVoted = response.vote;
      }

      this.getCandidate();
    },

    async putComment(){

      let fd = new FormData();
      fd.append("text", this.commentText);
      fd.append("vpid", this.$route.params.id);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("send_comment_voters",fd);

      if (response.status_code === 200) {
        this.resultVoted = response.result;
        this.votesVoted = response.vote;
      }
      this.commentText = "";

      this.$toast.open({
        message:"دیدگاه شما با موفقیت ذخیره گردید",
        type: 'success',
      });

      this.getCandidate();
    },

  },
};
</script>

<style lang="scss" scoped>
.voting-module {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding: 0px;
  direction: rtl;
  .candidate-container{
    width: 91%;
    margin: 0 auto;
    box-shadow: 9px 11px 43px #80808070;
    margin-top: 19px;
    border-radius: 12px;
    padding: 17px;
    .title-box{
      img{
        width: 33%;
        border-radius: 50%;
        border: 4px solid black;
        margin-top: 18px;
        display: flex;
      }
      h4{
        text-align: center;
      }
      .candidate-name{
        text-align: center;
        border-bottom: 1px solid #80808087;
        margin-bottom: 12px;
        padding-top: 13px;
        font-size: 20px;
      }
    }
    .candidate-lists{
      .comment-container{
        .input-box{
          input{
            border: none;
            border-bottom: 1px solid #e91e63;
            background:none;
            width:72%;
            color: #313131;
            &:focus{
              outline: none;
            }
          }
          .submitcomment{
            background: #536dfe;
            color: #ffffff;
            padding: 10px 15px 10px 15px;
            border-radius: 10px;
          }
          ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #ffffff;
            opacity: 1; /* Firefox */
          }

          :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #ffffff;
          }

          ::-ms-input-placeholder { /* Microsoft Edge */
            color: #ffffff;
          }
        }
        .comment-list{
          .comment-item{
            color: #000000;
            border-bottom: 1px solid #333333;
            padding-bottom: 7px;
            margin-bottom: 10px;
            .name-comment-box{
              padding-bottom: 5px;
              svg{
                color:gray;
              }
              p{
                padding-right: 6px;
                margin-bottom: 0;
              }
            }
            .comment-box{

            }
            .comment-date{
              text-align: left;
            }
          }

        }
      }

      .video-container{
        margin: 0 auto;
        display: flex;
        justify-content: center;
      }
      .voting-class{
        text-align: center !important;
        margin: 0 auto;
        display: flex;
        border: 1px solid #e91e63;
        color: #e91e63;
        width: 93%;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 14px;
        border-radius: 11px;
        padding: 9px;
      }

      .voted-class{
        text-align: center !important;
        margin: 0 auto;
        display: flex;
        border: 1px solid #e91e63;
        background: #e91e63;
        color: #ffffff;
        width: 93%;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 14px;
        border-radius: 11px;
        padding: 9px;
      }
    }
    .candidate-item{
      border-radius: 17px !important;
      border: none;
      box-shadow: 1px 3px 14px #8080804f;
      .candidate-name{
        text-align: center;
        border-bottom: 1px solid #9e9e9e;
        padding-bottom: 5px;
        padding-top: 11px;
        width: 90%;
        margin: 0 auto;
      }
      .candidate-des{
        .show-btn{
          background: #536DFE;
          border-radius: 108px;
          padding: 3px 10px 3px 10px;
          color: #ffffff;
          margin-bottom: 10px;
        }

        .vote-btn{
          background: #ffffff;
          border:1px solid #e91e63;
          border-radius: 108px;
          padding: 3px 10px 3px 10px;
          color: #e91e63;
          margin-bottom: 10px;
        }

        .vote-btn.active{
          background: #e91e63;
          border:1px solid #e91e63;
          border-radius: 108px;
          padding: 3px 10px 3px 10px;
          color: #ffffff;
          margin-bottom: 10px;
        }
      }
      img{
        width: 55%;
        border-radius: 50%;
        border: 3px solid black;
        margin-top: 15px;
      }
      strong{
        font-size: 17px;
        text-align: center;
        padding-bottom: 7px;
      }
    }
  }
}
</style>
